/*!
=========================================================
* 受注・確定見積一覧
=========================================================
*/
import React from "react";

import {
  Button,
  Row,
  Col,
  Label,
  CardHeader,
  CardTitle,
  Table
} from "reactstrap";

import Request from '../../common/Request';
import DialogBase from '../Base/DialogBase';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import InputText from '../FormParts/InputText'
import InputDatetime from '../FormParts/InputDatetime'
import InputRadio from '../FormParts/InputRadio'
import Definition from '../../common/Definition';
import OptionConvert from '../../common/OptionConvert';
import InputSelect from '../FormParts/InputSelect';
import WithRole from '../FormParts/ButtonWithRole';
import FormatCode from '../../common/FormatCode';
import format_url from '../../variables/format_url';
import GoogleDrive from  "../../common/GoogleDrive"
import { GetMessage, getErrorCodes } from "../../variables/message";
import ImageControl from '../FormParts/ImageControl'
import InputCheckBox from '../FormParts/InputCheckBox'
import StaticMap from '../../common/StaticMap'
import CustomTd from '../ViewParts/CustomTd';

import BadgeWithTooltip from '../FormParts/BadgeWithTooltip'
import custom_report from "../../variables/custom_report"
import { 
  cst_invoice_change_flag
 } from '../../variables/codes_map';

 const moment = require("moment");

class List extends ListBase {
  default_column = [
    { Header: '見積ID',accessor: 'ESTIMATE__estimate_number',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50,defaultView:true},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '顧客情報（下請）',accessor: '___JOIN_subcontract_customer_information',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,defaultView:true},
    { Header: '現場名/工事番号',accessor: '___JOIN_project_information_estimate',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true},
    { Header: '現場住所',accessor: '___JOIN_project_addr',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '仕入先情報',accessor: '___JOIN_quote_use_parking',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50,defaultView:true},
    { Header: '契約期間',accessor: '___JOIN_quote_available_date',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true},
    { Header: '契約担当者',accessor: 'ESTIMATE__contract_user_id',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, defaultView:true},
    { Header: '発注書',accessor: 'ESTIMATE__latest_pdf_purchase_order_url',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50,defaultView:true, sortable : false},
    { Header: '区画図登録',accessor: 'ESTIMATE__quote_plotting_picture_url',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50,defaultView:true, sortable : false},
    { Header: '送付',accessor: 'sendAction',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50,defaultView:true, sortable : false},
    { Header: '請求先情報',accessor: '___JOIN_invoice_change_master',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50,defaultView:true},
    { Header: '請求先設定',accessor: 'invoiceChangeAction',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true, sortable : false},
    { Header: '受注管理メモ',accessor: 'ESTIMATE__order_memo',headerClassName:'text-center',className:'text-left text-top',width:500,minWidth:50,defaultView:true},
    { Header: '強制請求依頼',accessor: 'invoiceRequestAction',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50,defaultView:true, sortable : false},
    { Header: '請求ロック',accessor: 'invoiceLockAction',headerClassName:'text-center',className:'text-left text-top',width:135,minWidth:50,defaultView:true, sortable : false},
    { Header: 'キャンセル申請ステータス',accessor: 'ESTIMATE__estimate_cancel_status',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true, sortable : false},
    { Header: 'キャンセル申請否認理由',accessor: 'ESTIMATE__estimate_cancel_return_memo',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true, sortable : false},
    { Header: 'キャンセル申請',accessor: 'estimateCancelAction',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,defaultView:true, sortable : false},
    { Header: '最終更新情報', accessor: '___JOIN_estimate_update', headerClassName: "text-center", className: "text-left text-top" ,width:225,defaultView:true},
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '確定見積一覧',
      add_url: '',
      base_search_url: '/api/quote',
      search_url: '/api/quote/unlimit',
      column: this.default_column,

      header_md:"3",
      SendNoInvoiceCount:"0",

      detail_search:false,
      valid: true,
      searchData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      landmark_user:[],
      user_list_for_lastupdate:[],
      auto_scroll:true,
    });

    this.dialog = React.createRef();
    this.dialogConfirm = React.createRef();
    this.dialogInvoiceRequest = React.createRef();
    this.dialogInvoiceLock = React.createRef();
    this.dialogEstimateCancel = React.createRef();
    this.dialogInvoiceCustomer = React.createRef();
    this.search = this.search.bind(this);
    this.search_count = this.search_count.bind(this);

    this.validateCallback = this.validateCallback.bind(this)
    this.setPropsForDialog = this.setPropsForDialog.bind(this)
    this.validateCallBackForDialog = this.validateCallBackForDialog.bind(this)
    this.getLastUpdaedUser = this.getLastUpdaedUser.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
//      console.log('user',res.Data);
      const user_list_for_lastupdate = OptionConvert.optionsById(res.Data)
      const user_list = res.Data.map((user)=>{
        return {value:user.id, label:user.name}
      })
      this.setState({
        landmark_user:user_list,
        user_list_for_lastupdate
      }, () => {
        this.search(false);
      });
    })
    StaticMap.googleMapScript()
  }

  componentWillUnmount(){
    window.google={}
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.user_list_for_lastupdate;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  dataMap(data) {
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}
      const cancelable = [4,5].includes(prop.estimate_status)
      
      return {
        id: key,
        sendAction:(
        <ButtonWithRole 
          button_id="BTN_F1_04_02690" size="sm" disabled={(prop.estimate_status != 4 || !(prop.latest_pdf_quote_url && prop.latest_pdf_plotting_url))} onClick={() => { this.setPropsForDialog(prop); this.dialogConfirm.current.show() }} color="info" className="text-center">送付</ButtonWithRole>),
        ESTIMATE__estimate_number: (<a href={`https://drive.google.com/open?id=${prop.latest_pdf_survey_url}`} target="_blank">{prop.estimate_natural_id}</a>),
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
        ___JOIN_project_information_estimate: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_estimate', prop)}} />,
        ___JOIN_project_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_quote_available_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date', prop)}} />,
        ESTIMATE__latest_pdf_purchase_order_url: (<a href={`/api/gcs_download/${prop.latest_pdf_purchase_order_url}?d=発注書_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">発注書確認</a>),
        ESTIMATE__quote_plotting_picture_url: <>
        <ButtonWithRole button_id="BTN_F1_04_02720" size="sm" onClick={() => { this.setPropsForDialog(prop); this.dialog.current.show() }} className="text-center" disabled={prop.estimate_status != 4}>区画図登録</ButtonWithRole>
          {prop.latest_pdf_quote_url && <>
            <br/>
            <a href={`https://drive.google.com/open?id=${prop.latest_pdf_quote_url}`} target="_blank">
              確定見積書確認
            </a>
          </>}
          {prop.latest_pdf_plotting_url && <>
            <br/>
              <a href={`https://drive.google.com/open?id=${prop.latest_pdf_plotting_url}`} target="_blank">
              区画図面確認
              </a>
          </>}
        </>,
        ESTIMATE__order_memo: prop.order_memo,
        ___JOIN_quote_use_parking: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_use_parking', prop)}} />,
        ___JOIN_estimate_update: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_estimate_update', prop_tmp)}} />,
        ESTIMATE__quote_plotting_number: prop.quote_plotting_number,
        invoiceRequestAction: 
        <>
          <ButtonWithRole 
            button_id="BTN_F1_04_02695" 
            size="sm" 
            className="text-center" 
            onClick={()=>{this.setPropsForDialog(prop); this.dialogInvoiceRequest.current.show()}} 
            disabled={prop.invoice_process_status != 0}>
              強制請求依頼
          </ButtonWithRole>
          {prop.invoice_process_status == 1 ? "請求依頼済" : ""}
        </>,
        invoiceLockAction: 
        <>
          <ButtonWithRole 
            button_id="BTN_F1_04_02696" 
            size="sm" 
            className="text-center" 
            onClick={()=>{this.setPropsForDialog(prop); this.dialogInvoiceLock.current.show()}} 
            disabled={!(prop.invoice_process_status == 0 || prop.invoice_process_status == 1)}>
              {(prop.invoice_lock_flag == 0 || prop.invoice_lock_flag == null) ? 'OFF' : 'ON' }
          </ButtonWithRole>
        </>,
        ESTIMATE__estimate_cancel_status : FormatCode.decode("cst_estimate_cancel_status", prop.estimate_cancel_status),
        ESTIMATE__estimate_cancel_return_memo : prop.estimate_cancel_return_memo,
        estimateCancelAction : 
        <>
          <ButtonWithRole 
            // button_id="BTN_F1_04_02695" 
            size="sm" 
            className="text-center" 
            onClick={()=>{
              // 請求済かつ売掛金の入金合計が０円以外の場合はキャンセルできない
              if(prop.receivable_collect_total_amt && prop.receivable_collect_total_amt !== 0){
                this.props.alertModal.current.showErrorModal({messageNo:2497});
                return false;
              }
              this.setPropsForDialog(prop); this.dialogEstimateCancel.current.show()
            }} 
            disabled={prop.customer_system_use_flag == 0 || !cancelable ||prop.estimate_cancel_status == 1 || prop.estimate_cancel_status == 2}
          >
              キャンセル申請
          </ButtonWithRole>
        </>,
        ___JOIN_invoice_change_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_invoice_change_master', prop)}} />,
        invoiceChangeAction:
        <>
          <ButtonWithRole 
            button_id="BTN_F1_04_02698" 
            size="sm" 
            className="text-center" 
            onClick={()=>{
              this.setPropsForDialog(prop); 
              this.dialogInvoiceCustomer.current.show()
            }} 
            >
              請求先設定
          </ButtonWithRole>
        </>,
        // 2022/07/11 
        ESTIMATE__contract_user_id: prop.contract_user_id!=null? this.state.landmark_user.filter(user=>prop.contract_user_id==user.value)[0]["label"] : ""
      }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
        this.setState({
          paging: {
            "index": parseInt(searchParmas["pager_index"]),
            "limit": parseInt(searchParmas["pager_limit"])
          },  
          data: this.dataMap(res.Data)
        });
    })

    Request.get(this.state.base_search_url, 
      {invoice_no_process_status:1}
      , res => {
        
        this.setState({
          SendNoInvoiceCount: res.Data.length
        });
      
    })
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
//        console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col md="4">
          <InputText
            label='案件ID'
            name='ESTIMATE__request_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="4">
          <InputText
            label='見積ID'
            name='ESTIMATE__estimate_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="4">
          <InputCheckBox
            label='確定見積送付済のデータを表示'
            name='ESTIMATE__estimate_status_send_quote_all'
            labelOn={false}
            validateCallback={this.validateCallback}
            checkedValue={1}
            uncheckedValue={0}
            rootData={this.state.searchData}
            validateType={'search'}
          /><br />
          <InputCheckBox
            label='確定見積送付済かつ請求書未生成のデータを表示'
            name='INVOICE__invoice_process_status'
            labelOn={false}
            validateCallback={this.validateCallback}
            checkedValue={1}
            uncheckedValue={0}
            rootData={this.state.searchData}
            validateType={'search'}
          /><br />
          <InputCheckBox
            label='確定見積送付済かつ未仕入のデータを表示'
            name='INVOICE__invoice_no_process_status'
            labelOn={false}
            validateCallback={this.validateCallback}
            checkedValue={1}
            uncheckedValue={0}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    const {
      SendNoInvoiceCount,
    } = this.state    
    return (
	<>
    <Col md="6"></Col>
    <Col md="3">
      <div style={{paddingTop: "35px"}}>確定送付済（未仕入）件数：<BadgeWithTooltip 
                    onclick={()=>{this.click();}}
                    class=""
                    id="tmp"
                    icon=""
                    link="#"
                    label={SendNoInvoiceCount}
                    message={"確定送付済（未仕入）件数が"+SendNoInvoiceCount+"件あります"}
                    size="sm" /></div> 
    </Col>              
	</>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<>
        <Col md="6">
          <InputSelect
            label="調査担当者"
            name="REQUEST__onsite_survey_account"
            labelOn={true}
            options={this.state.landmark_user}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            isSearchable={true}
            validateType={'search'}
          />
        </Col>
        <Col md="6">
          <InputDatetime
            label='見積提出期限（FROM）'
            name='REQUEST__estimate_deadline_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="6">
          <InputDatetime
            label='見積提出期限（TO）'
            name='REQUEST__estimate_deadline_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        {/*2022/07/11 契約担当者 */}
        <Col md="6">
          <InputSelect
            label='契約担当者'
            name='ESTIMATE__contract_user_id'
            labelOn={true}
            options={this.state.landmark_user}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
            validateType={'search'}
            isSearchable={true}
          />
        </Col>
      </>);
  }
  
  setPropsForDialog(props){
    const {
      project_natural_id
    } = props;
//    console.log("setPropsForDialog",props);
    Request.get('/api/construction/report',
      { project_natural_id },
      res => {
        let assignment = {
          send_destination_type:(res.Data[0].send_destination_type)? res.Data[0].send_destination_type: "",
          customer_user_email:(res.Data[0].customer_user_email)? res.Data[0].customer_user_email: "",
          subcontract_customer_user_email:(res.Data[0].subcontract_customer_user_email)? res.Data[0].subcontract_customer_user_email: "",
        }
/*
        const {
          send_destination_type
        } = res.Data[0]
*/
//        console.log(res.Data[0]);

        this.setState({
          dialogData:{
            values: Object.assign(props, assignment),
            errors:{},
            requiredData:{}
          }
        })
      }
    )
  }

  validateCallBackForDialog(newData, callback=()=>{}){
    const { quote_plotting_number } = newData.values;
    let requiredData = {}
    if(quote_plotting_number === undefined || quote_plotting_number === null || quote_plotting_number === ""){
      requiredData = { quote_plotting_number : [GetMessage(2024)] }
    }
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData,
        errors : {
          ...newData.errors,
          ...requiredData,
        }
      }
    }, ()=>callback())
  }

  dialog_defines() {
    //console.log("dialog_defines", this.state.dialogData);
    return (
      <>
        <Dialog ref={this.dialog} 
          validateCallBackForDialog = {this.validateCallBackForDialog}
          data={this.state.dialogData}
          updatePlottingDrawing = {this.updatePlottingDrawing}
          positive={true}
          positive_label="保存"
          negative_label="キャンセル"
          refreshCallback={this.search}
          {...this.props}
        />
        <DialogConfirm ref={this.dialogConfirm} 
          onConfirm={this.sendEstimate}
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
        <DialogInvoiceRequest 
          ref={this.dialogInvoiceRequest} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
        <DialogInvoiceLock 
          ref={this.dialogInvoiceLock} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
        <DialogEstimateCancel 
          ref={this.dialogEstimateCancel} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
        <DialogInvoiceCustomer 
          ref={this.dialogInvoiceCustomer} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
        <div id="googlemap" style={{display:"none"}}>
        </div>
      </>
    );    
  }
}
export class Dialog extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '区画図登録・更新',
      data: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
    this.EstimateQuoteCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].customer_natural_id; // 共ショウ
    this.requestEstimatePDF = this.requestEstimatePDF.bind(this)

  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      this.setState({
        data: {
          ...this.props.data,
          values:this.props.data.values,
          errors:{
            quote_plotting_number : this.props.data.errors.quote_plotting_number || (this.props.data.values.quote_plotting_number?undefined:[GetMessage(2024)]),
            ...(this.props.data.values.quote_plotting_picture_url?{}:{quote_plotting_picture_url:[GetMessage(2024)]})
          },
          requiredData:{
            quote_plotting_number:[GetMessage(2024)],
            quote_plotting_picture_url:[GetMessage(2024)],
          }
        }
      })
    }
  }
  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  requestEstimatePDF(estimateCommonParams, estimateData){
    //console.log(this.EstimateQuoteCustomizedForTomosho)
    //console.log(estimateData)
    return (this.EstimateQuoteCustomizedForTomosho==estimateData.customer_natural_id)
    ? new Promise((resolve, reject)=>{      
      const {
        id,
        survey_capacity_qty_type,
        survey_tax_in_flag,
        quote_available_start_date,
        quote_available_end_date,
        survey_discount_amt,
        survey_key_money,
        survey_commission_discount_amt,
        survey_adjustment_amt,
        quote_subtotal_amt,
        quote_tax_amt,
        quote_total_amt,
        estimate_details,
        latest_pdf_quote_url: original_latest_pdf_quote_url,
        invoice_customer_user_setting,
        customer_branch_invoice_zip_code,
        customer_branch_invoice_prefecture,
        customer_branch_invoice_city,
        customer_branch_invoice_address,
        invoice_customer_user_name,
        customer_user_name
      } = estimateData

      const invoice_user_name = invoice_customer_user_setting == 1 
      ? invoice_customer_user_name
      : invoice_customer_user_setting == 2 
        ? customer_user_name
        : ""

      let object_array_detail = {}
      let array_count = 0
      for(let i=1;i<=11;i++){
        const estimateDetail = estimate_details[i-1]
        if (estimateDetail){
          array_count++
          object_array_detail[`row_start_${i}`] = {
            ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
            ESTIMATE__quote_capacity_qty: estimateDetail.quote_capacity_qty, // ESTIMATE__survey_capacity_qty
            ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
            ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
            ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
            ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt
          }
        } else {
          object_array_detail[`row_start_${i}`] = {
            ESTIMATE_DETAIL__estimate_detail_name: "",
            ESTIMATE__quote_capacity_qty: "",
            ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
            ESTIMATE_DETAIL__estimate_detail_term: "",
            ESTIMATE_DETAIL__estimate_detail_term_type: "",
            ESTIMATE_DETAIL__estimate_detail_amt: ""
          }
        }
      }
      
      estimateCommonParams["object_estimate"]["ESTIMATE__id"] = id

      const pdfParams = {
        ...estimateCommonParams,
        format_url:GoogleDrive.getFormatUrl(format_url.Y13_PDF), 
        object_each_data:{
          CUSTOMER_BRANCH__tax_in_flag:survey_tax_in_flag,
          ESTIMATE__quote_available_start_date:quote_available_start_date,
          ESTIMATE__quote_available_end_date: quote_available_end_date,
          ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
          ESTIMATE__survey_discount_amt: survey_discount_amt,
          ESTIMATE__survey_key_money:survey_key_money,
          ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
          ESTIMATE__survey_adjustment_amt:survey_adjustment_amt,
          ESTIMATE__quote_subtotal_amt:quote_subtotal_amt,
          ESTIMATE__quote_tax_amt:quote_tax_amt,
          ESTIMATE__quote_total_amt: quote_total_amt,
          CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
          JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
          CUSTOMER_USER__customer_user_name : invoice_user_name,
          object_array_detail
        },
        object_common:{
          ...estimateCommonParams.object_common,
          array_count
        },
    
      }
      
      const pdfUrl = '/api/pout/Y13_PDF'+(original_latest_pdf_quote_url?`?sheet_id=${original_latest_pdf_quote_url}`:"")
      Request.post(pdfUrl, pdfParams, res=>{
        if (res.Code>=800){
          Request.setProgress(0)
          resolve(undefined)
        } else {
          resolve(res.Data)
        }
      }, err => {
        reject(err)
      })
    })
    :
     new Promise((resolve, reject)=>{      
      const {
        id,
        survey_capacity_qty_type,
        survey_tax_in_flag,
        quote_available_start_date,
        quote_available_end_date,
        survey_discount_amt,
        survey_key_money,
        survey_commission_discount_amt,
        survey_adjustment_amt,
        quote_subtotal_amt,
        quote_tax_amt,
        quote_total_amt,
        estimate_details,
        latest_pdf_quote_url: original_latest_pdf_quote_url,
        invoice_customer_user_setting,
        customer_branch_invoice_zip_code,
        customer_branch_invoice_prefecture,
        customer_branch_invoice_city,
        customer_branch_invoice_address,
        invoice_customer_user_name,
        customer_user_name
      } = estimateData

      const invoice_user_name = invoice_customer_user_setting == 1 
      ? invoice_customer_user_name
      : invoice_customer_user_setting == 2 
        ? customer_user_name
        : ""

      let object_array_detail = {}
      let array_count = 0
      for(let i=1;i<=11;i++){
        const estimateDetail = estimate_details[i-1]
        if (estimateDetail){
          array_count++
          object_array_detail[`row_start_${i}`] = {
            ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
            ESTIMATE__quote_capacity_qty: estimateDetail.quote_capacity_qty, // ESTIMATE__survey_capacity_qty
            ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
            ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
            ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
            ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt
          }
        } else {
          object_array_detail[`row_start_${i}`] = {
            ESTIMATE_DETAIL__estimate_detail_name: "",
            ESTIMATE__quote_capacity_qty: "",
            ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
            ESTIMATE_DETAIL__estimate_detail_term: "",
            ESTIMATE_DETAIL__estimate_detail_term_type: "",
            ESTIMATE_DETAIL__estimate_detail_amt: ""
          }
        }
      }
      estimateCommonParams["object_estimate"]["ESTIMATE__id"] = id
      const pdfParams = {
        ...estimateCommonParams,
        format_url:GoogleDrive.getFormatUrl(format_url.F01_PDF), 
        object_each_data:{
          CUSTOMER_BRANCH__tax_in_flag:survey_tax_in_flag,
          ESTIMATE__quote_available_start_date:quote_available_start_date,
          ESTIMATE__quote_available_end_date: quote_available_end_date,
          ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
          ESTIMATE__survey_discount_amt: survey_discount_amt,
          ESTIMATE__survey_key_money:survey_key_money,
          ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
          ESTIMATE__survey_adjustment_amt:survey_adjustment_amt,
          ESTIMATE__quote_subtotal_amt:quote_subtotal_amt,
          ESTIMATE__quote_tax_amt:quote_tax_amt,
          ESTIMATE__quote_total_amt: quote_total_amt,
          CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
          JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
          CUSTOMER_USER__customer_user_name : invoice_user_name,
          object_array_detail
        },
        object_common:{
          ...estimateCommonParams.object_common,
          array_count
        },
        customer_system_use_flag:estimateData["customer_system_use_flag"],
      }
      
      const pdfUrl = '/api/pout/F01_PDF'+(original_latest_pdf_quote_url?`?sheet_id=${original_latest_pdf_quote_url}`:"")
      Request.post(pdfUrl, pdfParams, res=>{
        if (res.Code>=800){
          Request.setProgress(0)
          resolve(undefined)
        } else {
          resolve(res.Data)
        }
      }, err => {
        reject(err)
      })
    })
  }

  async handleClickPositive(){
    if (!this.validate()){
      return;
    }

    const {
      estimate_natural_id,
      customer_branch_natural_id,
      customer_user_natural_id,
      project_natural_id,
      request_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      
      survey_capacity_flag_car,
      survey_capacity_flag_light_truck,
      quote_plotting_number,
      quote_capacity_qty,
      quote_available_start_date,
      quote_available_end_date,
      survey_parking_picture_url,
      survey_route_picture_url,
      quote_plotting_picture_url,
      survey_parking_address_contract,
      survey_site_distance_meter,
      survey_site_distance_minute,
      latest_pdf_plotting_url: original_latest_pdf_plotting_url,
      user_branch_natural_id,
      parking_latitude,
      parking_longitude,
      project_latitude,
      project_longitude,
      want_guide_type,
      want_guide_type_subcontract,
    } = this.state.data.values
    Request.setProgress(10)

    try{
      const estimateCommonParams = await Request.getEstimateCommon({
          customer_branch_natural_id,
          customer_user_natural_id,
          project_natural_id,
          request_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          estimateObject: this.state.data.values,
          user_branch_natural_id
      })
      const estimate_detail_data = await new Promise(resolve=>{
        // 確定見積詳細取得API呼び出し
        Request.get(`/api/estimate/detail/quote/${estimate_natural_id}`, {}, res=>{
          if (!res.Data[0]){
            Request.setProgress(0)
            throw {
              name:'Data Error!',
              message:'estimate detail not exist'
            }
          }
          resolve(res.Data.map(datum=>{
            const {
              estimate_detail_name,
              estimate_detail_qty,
              estimate_detail_unit_cost,
              estimate_detail_term,
              estimate_detail_term_type,
              estimate_detail_amt
            } = datum
            return{
              estimate_detail_name,
              quote_capacity_qty:estimate_detail_qty, // ESTIMATE__survey_capacity_qty
              estimate_detail_unit_cost,
              estimate_detail_term,
              estimate_detail_term_type,
              estimate_detail_amt
            }
          }))
        })
      })
      Request.setProgress(20)
      // create static map
      const routeData = await StaticMap.createStaticGoogleMap(
        {
          latitude: project_latitude,
          longitude: project_longitude
        }, 
        [{
          latitude: parking_latitude,
          longitude: parking_longitude
        }],
        [],
        true
      )
      const uploadResult = await StaticMap.uploadCanvas(routeData[0].canvas, 'q_route_picture')
      
      Request.setProgress(30)
      const zoomedUploadResult = await StaticMap.uploadZoomedRoute(
        routeData[0],
        {
          latitude: parking_latitude,
          longitude: parking_longitude
        },
        'q_route_zm_picture'
      )

      const estimateData = {
        ...this.state.data.values,
        quote_route_picture_url: uploadResult.id,
        ESTIMATE__quote_route_picture_url: GoogleDrive.getDownloadUrl(uploadResult.id),
        quote_route_zoom_picture_url: zoomedUploadResult.id,
        ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(zoomedUploadResult.id),
        estimate_details:estimate_detail_data
      }
      Request.setProgress(40)
      const Pdf01Result = quote_plotting_picture_url && await this.requestEstimatePDF(estimateCommonParams, estimateData)
      if (!Pdf01Result){
        Request.setProgress(0)
        this.props.alertModal.current.showErrorModal({
          messageNo: 2474
        })
        return 
      }
      Request.setProgress(60)
      const Pdf02Result = await new Promise((resolve, reject)=>{
        const pdfUrl = '/api/pout/F02_PDF'+(original_latest_pdf_plotting_url?`?sheet_id=${original_latest_pdf_plotting_url}`:"")
        const pdfParams = {
          ...estimateCommonParams,
          format_url:GoogleDrive.getFormatUrl(format_url.F02_PDF),
          object_each_data:{
            ESTIMATE__survey_capacity_flag_car:survey_capacity_flag_car,
            ESTIMATE__survey_capacity_flag_light_truck:survey_capacity_flag_light_truck,
            ESTIMATE__quote_plotting_number:quote_plotting_number,
            ESTIMATE__quote_capacity_qty:quote_capacity_qty,
            ESTIMATE__quote_available_start_date:quote_available_start_date,
            ESTIMATE__quote_available_end_date:quote_available_end_date,
            ESTIMATE__survey_parking_picture_url:GoogleDrive.getDownloadUrl(survey_parking_picture_url),
            ESTIMATE__latest_pdf_route_url:survey_route_picture_url,
            ESTIMATE__quote_plotting_picture_url:GoogleDrive.getDownloadUrl(quote_plotting_picture_url),
            ESTIMATE__survey_parking_address_contract:survey_parking_address_contract,
            JOIN_parking_addr: estimateCommonParams.object_estimate.JOIN_parking_addr,
            REQUEST_PARKING__site_distance_minute:survey_site_distance_minute,
            REQUEST_PARKING__site_distance_meter:survey_site_distance_meter,
            ESTIMATE__quote_route_picture_url: uploadResult.url,
            ESTIMATE__quote_route_zoom_picture_url: zoomedUploadResult.url
          },
          customer_system_use_flag:estimateData["customer_system_use_flag"],
        }
        Request.post(pdfUrl, pdfParams, res=>{
          if (res.Code>=800){
            Request.setProgress(0)
            resolve(undefined)
          } else {
            resolve(res.Data)
          }
        }, err=>{
          reject(err)
        })
      })
      if (!Pdf02Result){
        Request.setProgress(0)
        this.props.alertModal.current.showErrorModal({
          messageNo: 2475
        })
        return;
      }
      Request.setProgress(70)
      // const ESTIMATE__latest_pdf_quote_url = Pdf01Result&&Pdf01Result.file_id
      const latest_pdf_quote_url = Pdf01Result&&Pdf01Result.spreadsheet_id
      // const ESTIMATE__latest_pdf_plotting_url = Pdf02Result&&Pdf02Result.file_id
      const latest_pdf_plotting_url = Pdf02Result&&Pdf02Result.spreadsheet_id

      const file_upload = await new Promise((resolve,reject)=>{
        
        const url = '/api/quote/file_upload/' + estimateData.ulid
        const uploadParams = {
          ...estimateData,
          latest_pdf_quote_url,
          latest_pdf_plotting_url}

        Request.put(url, uploadParams, res =>{
          this.setState( prevState => ({
            ...prevState,
            data:{
              ...prevState.data,
              values:{
                ...prevState.data.values,
                update_timestamp: res.Data.update_timestamp
              }
            }
          }))
          resolve(res)
        }, err => reject(err));
      })
    
      

      const {
        PROJECT__send_destination_type
      } = estimateCommonParams.object_project

      const isMailAllowed =  ((want_guide_type=="1"||want_guide_type=="0")  && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2")) 
      || ((want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0")  && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2")) 

      const {
        CUSTOMER_USER__customer_reminder_sms_flag_code,
        CUSTOMER_USER__customer_user_tel
      } = estimateCommonParams.object_customer

      const {
        CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
        CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
      } = estimateCommonParams.object_customer_subcontract

      const isSmsAllowed = ((PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) 
      || ((PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract) 


      Request.setProgress(0)
    
      this.props.alertModal.current.confirmCheck({
        title: "処理完了",
        messageNo: 2417,
        closeBtn: false
      }, ()=>{
        this.toggleModal()
        this.props.refreshCallback()
      }, false)

    }catch(err){
      Request.setProgress(0)
      this.props.alertModal.current.showErrorModal({
        messageNo: 2476
      })
    }
  }

  bodyContent() {
    return (
      <>
        <div>
          <Label>区画図：</Label>
          {
            this.state.data.values.quote_plotting_picture_url &&
            <a className="link" target='_blank' href={GoogleDrive.getDownloadUrl(this.state.data.values.quote_plotting_picture_url, `区画図_${moment().format("YYYYMMDDHHmmss")}`)}>区画図確認</a>
          }
          <span style={{float:"right"}}>
            <ImageControl 
              gcs_path="q_plotting_picture"
              uploadCallback={(croppedImageObject)=>{
                  const {
                    id, 
                  } = croppedImageObject
                  this.props.validateCallBackForDialog({
                    ...this.state.data,
                    values:{
                      ...this.state.data.values,
                      quote_plotting_picture_url: id
                    }
                  })
              }}
              buttonName = {"ファイル選択"}
              cropData={{
                unit: '%',
                width: 30,
                aspect: (1260 / 1260),
              }}
            />
          </span>
          <p style={{color : "red"}}>{!this.state.data.values.quote_plotting_picture_url && GetMessage(2024)}</p>
        </div>
        <InputText
            label='契約区画番号'
            labelOn={true}
            name='ESTIMATE__quote_plotting_number'
            validateCallback={this.props.validateCallBackForDialog}
            rootData={this.state.data}
            validateType="regist"
          />
      </>
    );
  }
}
export class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);

    const {
      send_destination_type,
      customer_branch_cc_email_quote,
      subcontract_customer_branch_cc_email_quote,
      customer_branch_fax,
      subcontract_customer_branch_fax,
      cc_email
    } = this.props.data.values;


    var email = [];
    //  console.log(this.props.data.values);
    var sub_email = [];
    // console.log(this.props.data.values);

    console.log(send_destination_type);
    console.log(cc_email);

    if(send_destination_type =="1"){
      if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
        sub_email.push(cc_email)
      }
      
      if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
        sub_email.push(subcontract_customer_branch_cc_email_quote)
      }
    }else{
      if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
        email.push(cc_email)
      }
      if (customer_branch_cc_email_quote !== null && customer_branch_cc_email_quote !== undefined && customer_branch_cc_email_quote.length>0) {
        email.push(customer_branch_cc_email_quote)
      }

      if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
        sub_email.push(subcontract_customer_branch_cc_email_quote)
      }

    }


    Object.assign(this.state, {
      title: '確定見積書を送付します。よろしいですか？',
      data: this.props.data,
      notification: {
        values: {
          customer_user_email:(this.props.data.values.customer_user_email)? this.props.data.values.customer_user_email: "",
          subcontract_customer_user_email:(this.props.data.values.subcontract_customer_user_email)? this.props.data.values.subcontract_customer_user_email: "",
          want_guide_type: (this.props.data.values.want_guide_type)? parseInt( this.props.data.values.want_guide_type ): 0,
          want_guide_type_subcontract: (this.props.data.values.want_guide_type_subcontract)? parseInt( this.props.data.values.want_guide_type_subcontract ): 0,
          send_destination_type: (this.props.data.values.send_destination_type)? parseInt(this.props.data.values.send_destination_type): 0,
          cc_email: (email.length>0)?email.join(","):"",
          cc_email_subcon: (sub_email.length>0)?sub_email.join(","):"",
          fax: (customer_branch_fax && customer_branch_fax != null)? customer_branch_fax: "",
          subcon_fax: (subcontract_customer_branch_fax && subcontract_customer_branch_fax != null)? subcontract_customer_branch_fax: "",
        },
        errors: {},
        requiredData:{}
      }
    });

    this.EstimateQuoteCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].customer_natural_id; // 共ショウ
    this.DocumentNameCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].document_name; // 共ショウ

    this.memoValidateCallback = this.memoValidateCallback.bind(this)
    this.validateCallback = this.validateCallback.bind(this)
    this.handleClickPositive = this.handleClickPositive.bind(this)
    this.subconSendSettingDisabled = this.subconSendSettingDisabled.bind(this);
    this.sendSettingDisabledOptions = this.sendSettingDisabledOptions.bind(this);
    this.validateSendContact = this.validateSendContact.bind(this);
    this.renderSendSetting = this.renderSendSetting.bind(this);
    this.validNotificateStatus = this.validNotificateStatus.bind(this);
  }

  componentDidUpdate(prevProps){
    
    if (prevProps.data !== this.props.data){
      const {
        send_destination_type,
        want_guide_type,
        want_guide_type_subcontract,
        customer_branch_cc_email_quote,
        subcontract_customer_branch_cc_email_quote,
        customer_branch_fax,
        subcontract_customer_branch_fax,
        customer_user_email,
        subcontract_customer_user_email,
        cc_email
      } = this.props.data.values;
      var email = [];
      var sub_email = [];
      let set_send_destination_type;
      // console.log(cc_email);
      if(send_destination_type == "" || send_destination_type == null){
        set_send_destination_type = 0;
      }else{
        set_send_destination_type = parseInt(send_destination_type);
      }

      if(set_send_destination_type == 1){
        if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
          sub_email.push(cc_email)
        }
        
        if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
          sub_email.push(subcontract_customer_branch_cc_email_quote)
        }
      }else{
        if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
          email.push(cc_email)
        }
        if (customer_branch_cc_email_quote !== null && customer_branch_cc_email_quote !== undefined && customer_branch_cc_email_quote.length>0) {
          email.push(customer_branch_cc_email_quote)
        }

        if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
          sub_email.push(subcontract_customer_branch_cc_email_quote)
        }
  
      }

      console.log("componentDidUpdate",this.props.data);

      this.setState({
        data: {
          ...this.props.data,
          values : {
            ...this.props.data.values,
            invoice_user_memo : this.props.data.values.order_memo
          }
       },
       notification: {
         ...this.state.notification,
        values: {
            ...this.state.notification.values,
            customer_user_email:customer_user_email,
            subcontract_customer_user_email:subcontract_customer_user_email,
            send_destination_type:set_send_destination_type,
            want_guide_type:(want_guide_type)? parseInt( want_guide_type ): this.state.notification.values.want_guide_type,
            want_guide_type_subcontract:(want_guide_type_subcontract)? parseInt( want_guide_type_subcontract ): this.state.notification.values.want_guide_type_subcontract,
            cc_email: (email.length>0)?email.join(","):"",
            cc_email_subcon:  (sub_email.length>0)?sub_email.join(","):"",
            fax: (customer_branch_fax && customer_branch_fax != null)? customer_branch_fax: "",
            subcon_fax: (subcontract_customer_branch_fax && subcontract_customer_branch_fax != null)? subcontract_customer_branch_fax: "",
        }
       }
      }/*,()=>console.log(this.state.notification.values)*/)
    }
  }
  validateSendContact ( newData, callback=()=>{}) {
//    console.log("validateSendContact",newData);
    this.setState({ notification: {
      ...this.state.notification,
      ...newData
/*
      values: {
        ...this.state.notification.values,
        ...newData.values
      },
*/
    }
  },/*()=>console.log(this.state.notification)*/);
  
  }
  sendSettingDisabledOptions(distinate_type="contract"){
    const EmailSendEnabled = this.subconSendSettingDisabled("email",distinate_type) ;
    const FaxSendEnabled = this.subconSendSettingDisabled("fax",distinate_type) ;
    console.log(EmailSendEnabled,FaxSendEnabled)
		if(!EmailSendEnabled && FaxSendEnabled){
		  return [0,2]
		}else if(EmailSendEnabled && !FaxSendEnabled){
		  return [0,1]
		}else{
		  return []
		}
	
  } 

  // #1034 案内設定 0:PCのみ  1:FAXのみ  2:両方
  subconSendSettingDisabled (send_type="email",distinate_type="contract") {
    //console.log(this.state.notification);
    switch (send_type){
      case "email":{
        const {
          send_destination_type,
          customer_user_email,
          subcontract_customer_user_email
        }=this.state.notification.values
        
        let validCheck
        let sendSettingCheck
        if (distinate_type=="contract") {
          validCheck = customer_user_email.length > 0
          sendSettingCheck = send_destination_type == 2 || send_destination_type == 0
        }
        else {
          validCheck = subcontract_customer_user_email.length > 0
          sendSettingCheck = send_destination_type == 2 || send_destination_type == 1
        }
        return !sendSettingCheck || !validCheck
      }
      case "fax":{
        const {
          send_destination_type
        }=this.state.notification.values

        let sendSettingCheck

        if (distinate_type=="contract") {
          sendSettingCheck = send_destination_type == 2 || send_destination_type == 0
        }
        else {
          sendSettingCheck = send_destination_type == 2 || send_destination_type == 1
        }
        return !sendSettingCheck
      }
      // 案内送信設定 0:元請のみ 1:下請のみ 2:両方
      case "dist": {
        // 元請、下請双方に送信
        if (this.state.notification.values.send_destination_type == 2) return false;
        // 元請送信設定
        if (distinate_type == "contract") {
          return (this.state.notification.values.send_destination_type != 0)
        }
        else 
          return (this.state.notification.values.send_destination_type != 1)
        }
    }
  }

  validNotificateStatus ( checkValidError = true, contract = true,subcon = true ) {
    let valid = true
    if ( checkValidError ) {
      let message = getErrorCodes(this.state.notification.errors)
      if(message.length > 0){
        valid = false;
      }
    }
    const {
      send_destination_type,
      want_guide_type,
      want_guide_type_subcontract,
      fax,
      subcon_fax
    }=this.state.notification.values
    //send_destination_type 0:元請のみ 1:下請のみ  2:両方
    //want_guide_type 0:両方 1:メールのみ  2:ファックスのみ
    
    if ( contract ) {
      // 元請のファックス案内=>ファックスのNULLチェック
      if ((send_destination_type==0 || send_destination_type == 2) && (want_guide_type == 0 || want_guide_type == 2)) {
        if (fax.length == 0) { valid = false }
      }
    }
    if ( subcon ) {
      // 元請のファックス案内=>ファックスのNULLチェック
      if ((send_destination_type==1 || send_destination_type == 2) && (want_guide_type_subcontract == 0 || want_guide_type_subcontract == 2)) {
        if (subcon_fax.length == 0 ) { valid = false }
      }
    }
    return valid;
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  async handleClickPositive(){
//    console.log("handleClickPositive",this.state.data.values);
    if ( !this.validNotificateStatus() ) {
      return false;
    }

    if (!this.validate()) {
      return false;
    }

    const {
//      want_guide_type,
//      want_guide_type_subcontract,

      customer_natural_id,
      customer_branch_natural_id,
      customer_user_natural_id,
      project_natural_id,
      request_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,

      latest_pdf_quote_url,
      latest_pdf_plotting_url,
      invoice_status_flag,
      user_branch_natural_id,
      invoice_user_memo,
      change_invoice_flag,
      change_invoice_name,
    } = this.state.data.values
    
    Request.setProgress(10)
    const estimateCommonParams = await Request.getEstimateCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        estimateObject: this.state.data.values,
        user_branch_natural_id
    })
    
    Request.setProgress(20)
    const ESTIMATE__latest_pdf_quote_url = latest_pdf_quote_url
    const ESTIMATE__latest_pdf_plotting_url = latest_pdf_plotting_url
    const {
      CUSTOMER_USER__customer_reminder_sms_flag_code,
      CUSTOMER_USER__customer_user_tel
    } = estimateCommonParams.object_customer
    const {
      CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
      CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
    } = estimateCommonParams.object_customer_subcontract
/*
    const {
      PROJECT__send_destination_type
    } = estimateCommonParams.object_project
*/
    // #1034 送信設定　DB参照→手動設定
    const {
      customer_user_email,
      subcontract_customer_user_email,
      want_guide_type,
      want_guide_type_subcontract,
      fax,
      subcon_fax
    }=this.state.notification.values

    let {
      send_destination_type,
      send_destination_type:PROJECT__send_destination_type,
    } = this.state.notification.values

    // 顧客システム情報利用有無
    const useCustomerSystem = this.state.data.values.customer_system_use_flag;
    // 通知フラグ
    const sendUploadNotification = this.state.notification.values.send_upload_notification;
    const custSendFlag = (useCustomerSystem === 1 && sendUploadNotification === 1) ? true : false;

    // 顧客システム利用の場合は元請は通知だけ送るため、下請けのみ作成
    if(useCustomerSystem === 1){
      PROJECT__send_destination_type = 1
    }

    // #1034 入力されたメール・ファックス番号に変更
    const castEstimateParameters = {
      ...estimateCommonParams,
      object_customer: {
        ...estimateCommonParams.object_customer, 
        CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email,
        CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.fax,
      },
      object_customer_subcontract: {
        ...estimateCommonParams.object_customer_subcontract, 
        CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email_subcon,
        CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.subcon_fax,
      }
    }


    const send_document_1_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_1:"";
    const send_document_2_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_2:"";
    const subcontract_send_document_1_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_1:"";
    const subcontract_send_document_2_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_2:"";

    const send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_1:"";
    const send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_2:"";
    const subcontract_send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_1:"";
    const subcontract_send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_2:"";

    const send_document_1_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_1:"";
    const send_document_2_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_2:"";
    const subcontract_send_document_1_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_1:"";
    const subcontract_send_document_2_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_2:"";

    const send_customized_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?"1":"0";

    let f03Mail, f03Fax, f03Sms
		if(this.props.register_type == 0) {
      f03Mail =  ((want_guide_type=="1"||want_guide_type=="0")  && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && customer_user_email.length > 0) 
      || ((want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0")  && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcontract_customer_user_email.length > 0) 
      ? new Promise((resolve, reject)=>{

        // 依頼元担当者のメールアドレスがNullでは無い AND 「メールを送信する」（REQUEST__want_guide_type）となっていること
        const mailUrl = '/api/pout/F03_MAIL'
        const mailParams = {
  //        ...estimateCommonParams,
          ...castEstimateParameters,
          send_destination_type:PROJECT__send_destination_type,
          want_guide_type:want_guide_type,
          want_guide_type_subcontract:want_guide_type_subcontract,
          format_url:GoogleDrive.getFormatUrl(format_url.F03_MAIL),
          ESTIMATE__latest_pdf_quote_url,
          ESTIMATE__latest_pdf_plotting_url,
          send_customized_flag,
          object_each_data:{
            send_document_1:send_document_1_mail,
            send_document_2:send_document_2_mail,
            subcontract_send_document_1:subcontract_send_document_1_mail,
            subcontract_send_document_2:subcontract_send_document_2_mail
          }
        }
        Request.post(mailUrl, mailParams, res=>{
  //        console.log(res)
          resolve(res)
        }, err=>{
          reject(err)
        })
      })
      :{Code:200}
      

      

      f03Fax = ((want_guide_type=="2"||want_guide_type=="0") && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && fax.length>0) 
      || ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcon_fax.length>0) 
      ? new Promise((resolve, reject)=>{
        const faxUrl = '/api/pout/F03_FAX'
        const faxParams = {
  //        ...estimateCommonParams,
          ...castEstimateParameters,
          send_destination_type:PROJECT__send_destination_type,
          want_guide_type:want_guide_type,
          want_guide_type_subcontract:want_guide_type_subcontract,
          format_url:GoogleDrive.getFormatUrl(format_url.F03_FAX),
          ESTIMATE__latest_pdf_quote_url,
          ESTIMATE__latest_pdf_plotting_url,
          send_customized_flag,
          object_each_data:{
            send_document_1:send_document_1_fax,
            send_document_2:send_document_2_fax,
            subcontract_send_document_1:subcontract_send_document_1_fax,
            subcontract_send_document_2:subcontract_send_document_2_fax
          }
        }
        Request.post(faxUrl, faxParams, res=>{
          //console.log(res)
          resolve(res)
        }, err=>{
          reject(err)
        })
      })
      :{Code:200}

      f03Sms = ((PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) 
      || ((PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract) 
      ? new Promise((resolve, reject)=>{
        // need to fix condition
        const smsUrl = '/api/pout/F03_SMS'
        const smsParams = {
          ...estimateCommonParams,
          send_destination_type:PROJECT__send_destination_type,
          want_guide_type:want_guide_type,
          want_guide_type_subcontract:want_guide_type_subcontract,
          format_url:GoogleDrive.getFormatUrl(format_url.F03_SMS),        
          ESTIMATE__latest_pdf_quote_url,
          ESTIMATE__latest_pdf_plotting_url,
          send_customized_flag,
          object_each_data:{
            send_document_1:send_document_1_sms,
            send_document_2:send_document_2_sms,
            subcontract_send_document_1:subcontract_send_document_1_sms,
            subcontract_send_document_2:subcontract_send_document_2_sms
          }
        }
        Request.post(smsUrl, smsParams, res=>{
  //        console.log(res)
          resolve(res)
        }, err=>{
          reject(err)
        })
      })
      :{Code:200}

      Request.setProgress(40)
      const f0304results = await Promise.all([f03Mail, f03Fax, f03Sms]).then(r=>r)
      Request.setProgress(70)
      f03Mail = f0304results[0]
      f03Fax = f0304results[1]
      f03Sms = f0304results[2]
    }

    let f10_mail = null;
    let f10_sms = null;
    
    // 顧客システムへの通知がある場合
    if(this.props.register_type == 1 && custSendFlag){
      // 顧客システム通知用メール取得
      f10_mail = await new Promise((resolve, reject)=>{
        const mailUrl = '/api/pout/F10_MAIL'
        const mailParams = {
          ...estimateCommonParams,
          send_destination_type:0,
          want_guide_type:want_guide_type,
          want_guide_type_subcontract:want_guide_type_subcontract,
          format_url:GoogleDrive.getFormatUrl(format_url.F10_MAIL),
        }
        
        Request.post(mailUrl, mailParams, res=> resolve(res), err=> reject(err))
      })  
      
      // 顧客システム通知用SMS取得
      f10_sms = CUSTOMER_USER__customer_reminder_sms_flag_code == "1" && CUSTOMER_USER__customer_user_tel && await new Promise((resolve, reject)=>{
        const smsUrl = '/api/pout/F10_SMS'
        const smsParams = {
          ...estimateCommonParams,
          send_destination_type:0,
          want_guide_type:want_guide_type,
          want_guide_type_subcontract:want_guide_type_subcontract,
          format_url:GoogleDrive.getFormatUrl(format_url.F10_SMS),
        }
        Request.post(smsUrl, smsParams, res => resolve(res), err=> reject(err))
      })
    }
    
    Request.setProgress(80)
    // if (f03Mail.Code==200 && f03Fax.Code==200 && f03Sms.Code==200){
    const url = '/api/quote/send/'+this.props.data.values.ulid
    Request.put(url, {
      ...this.props.data.values,
      latest_pdf_quote_url,
      latest_pdf_plotting_url,
      invoice_status_flag,
      invoice_user_memo,
      change_invoice_flag,
      change_invoice_name,
    }, async (res)=>{

        // 顧客システム利用かつ通知を送る
        if(this.props.register_type == 1 && custSendFlag){
          const sendMail = f10_mail && await new Promise((resolve, reject)=>{
            const sendMailUrl = '/api/send/AUTOMAIL'
            const sendMailParams = f10_mail.data
            Request.post(sendMailUrl, sendMailParams, res=> resolve(res), err=> reject(err))
          })  
          const sendSms = f10_sms && await new Promise((resolve, reject)=>{
            const sendSmsUrl = '/api/send/SMS'
            const sendSmsParams = f10_sms.data
            Request.post(sendSmsUrl, sendSmsParams, res=> resolve(res), err=> reject(err))
          })
        }

        Request.setProgress(90)

        let openGoogleDraft = false;
        // 顧客システム利用時は送付状を送らず、通知メールとSMSを送る（元請けのみ）
        // 顧客システム利用かつ元請けのみの場合、送付状不要
        if(this.props.register_type == 0) {
          if(!(useCustomerSystem && send_destination_type == 0)){
            // 顧客システム未利用又は顧客システム利用且つ下請け、両方の場合
            const sendMailUrl = '/api/send/MAIL'
            f03Mail.Data&&f03Mail.Data.forEach((mailData)=>{
              openGoogleDraft = true;
              Request.post(sendMailUrl, mailData, res=>{
              }, err=>{
              },undefined, true, false)
            })
            
            const sendFaxUrl = '/api/send/FAX'
            f03Fax.Data&&f03Fax.Data.forEach((faxData)=>{
              Request.post(sendFaxUrl, faxData, res=>{
              }, err=>{
              },undefined, true, false)
            })
    
            const sendSmsUrl = '/api/send/SMS'
            f03Sms.Data&&f03Sms.Data.forEach((smsData)=>{
              Request.post(sendSmsUrl, smsData, res=>{
              }, err=>{
              },undefined, true, false)
            })
          }
        }
        Request.setProgress(0)
        if (res.data.Code==200){
          // if(((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0")) 
          // ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
          if(openGoogleDraft){
            window.open(`https://mail.google.com/mail/u/0/#drafts`);
          }
          this.props.refreshCallback()
          this.props.alertModal.current.confirmCheck({
            title: "処理完了",
            messageNo: [2417,2471],
            closeBtn: false
          }, ()=>{
            this.toggleModal()
          }, false)
        }
      })
    // }
    Request.setProgress(0)
  }

  memoValidateCallback(newData, callback=()=>{}){
    this.setState({
      data:newData
    }, ()=>callback())
  }

  validateCallback(newData, callback=()=>{}){
    const change_invoice_flag = newData.values.change_invoice_flag
    const is_empty_change_invoice_name = 
      (newData.values.change_invoice_name === null 
      || newData.values.change_invoice_name === undefined
      || newData.values.change_invoice_name === "") ? true : false;
    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values: {
          ...newData.values,
          change_invoice_name : change_invoice_flag == 1 ? newData.values.change_invoice_name : null
        },
        errors:{ 
          ...(change_invoice_flag == 1 ? newData.errors : undefined),
          ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) 
        },
        requiredData : { ...(change_invoice_flag == 1 ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
      }
    }, ()=>callback())
  }

  bodyContent() {
    const { change_invoice_flag } = this.state.data.values;
    return (
      <>
        {this.renderSendSetting()}
        <Row style={{marginBottom: "0.5rem"}}>
          <Col md="3">
            請求先情報
          </Col>
          <Col md="8">
          <InputRadio
            options={cst_invoice_change_flag}
            name='ESTIMATE__change_invoice_flag'
            validateCallback={this.validateCallback} 
            validateType='regist'
            rootData={this.state.data}
          />
        </Col>
        </Row>

        <Row style={{marginBottom: "0.5rem"}}>
          <Col md="3">
            請求先名
          </Col>
          <Col md="8">
            <InputText 
              name='ESTIMATE__change_invoice_name'
              validateCallback={this.validateCallback} 
              validateType='regist'
              rootData={this.state.data}
              disabled={change_invoice_flag == 0}
            />
          </Col>
        </Row>

        <InputText multiline={true}
          labelOn={true}
          label='経理課への請求メモ（確定見積送付時に入力）'
          name='INVOICE__invoice_user_memo'
          copy="false"
          validateCallback={this.memoValidateCallback} 
          rootData={this.state.data}
          validateType='regist'
        />
        <InputCheckBox 
          label="仕入が未完了でも請求依頼済にする"
          name="TEMP__invoice_status_flag" 
          validateCallback={this.memoValidateCallback} 
          checkedValue={1}
          uncheckedValue={0}
          rootData={this.state.data}
        />
      </>
    );
  }
  renderSendSetting () {
    //console.log("renderSendSetting",this.state.notification.values);
    return (<>
      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="12">連絡先情報：</Col>
      </Row>
      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
        CCメールアドレス
        </Col>      
        <Col md="8">
          <InputText
            label='CCメールアドレス'
            labelOn={false}
            name='NOTIFICATION__cc_email'
            default={this.state.notification.values.cc_email}
            validateCallback={this.validateSendContact}
            rootData={this.state.notification}
            validateType="regist"
            disabled={this.subconSendSettingDisabled()}
          />
        </Col>      
      </Row>
      {this.state.data.values.customer_system_use_flag !== 1 ? 
      <>
        <Row style={{marginBottom: "0.5rem"}}>
          <Col md="3">
          FAX番号
          </Col>
          <Col md="8">
            <InputText
              label='FAX番号'
              labelOn={false}
              name='NOTIFICATION__fax'
              default={this.state.notification.values.fax}
              validateCallback={this.validateSendContact}
              rootData={this.state.notification}
              validateType="regist"
              disabled={this.subconSendSettingDisabled("fax")}
            />
            {!this.validNotificateStatus(false,true,false)&&(<p style={{color:"red"}}>
              {GetMessage(["2024"])}
            </p>)}
          </Col>
        </Row>
        <Row style={{marginBottom: "0.5rem"}}>
          <Col md="3">
          案内方法
          </Col>
          <Col md="8">
            <InputRadio
              name='NOTIFICATION__want_guide_type'
              disabled={this.subconSendSettingDisabled("dist")}
              disabled_options={this.sendSettingDisabledOptions("contract")}
              options={
                [
                  {
                      default : this.state.notification.values.want_guide_type,
                      label : "両方",
                      value : 0,
                  },
                  {
                    label : "Eメール案内希望",
                    value : 1
                  },
                  {
                    label : "FAX案内希望",
                    value : 2,
                  },
                ]
              }
              validateCallback={this.validateSendContact} 
              validateType='regist'
              rootData={this.state.notification}
              />
          </Col>
        </Row>
      </>
      :
      <>
        {/* <Row>
          <Col md="3">
            案内方法
          </Col>
          <Col>
            <InputCheckBox 
              label="確定見積書通知を送る"
              name="NODB__send_upload_notification" 
              validateCallback={this.validateSendContact} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.notification}
              disabled={!Boolean(this.state.data.values.customer_system_use_flag)}
            />
          </Col>
        </Row> */}
      </>
      }

      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
        CCメールアドレス（下請）
        </Col>      
        <Col md="8">
          <InputText
            disabled={this.subconSendSettingDisabled("email","subcon")}
            label='CCメールアドレス（下請）'
            labelOn={false}
            name='NOTIFICATION__cc_email_subcon'
            default={this.state.notification.values.cc_email_subcon}
            validateCallback={this.validateSendContact}
            rootData={this.state.notification}
            validateType="regist"
          />
        </Col>      
      </Row>
      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
        FAX番号（下請）
        </Col>      
        <Col md="8">
          <InputText
            disabled={this.subconSendSettingDisabled("fax","subcon")}
            label='FAX番号（下請）'
            labelOn={false}
            name='NOTIFICATION__subcon_fax'
            default={this.state.notification.values.fax}
            validateCallback={this.validateSendContact}
            rootData={this.state.notification}
            validateType="regist"
          />
          {!this.validNotificateStatus(false,false,true)&&(<p style={{color:"red"}}>
            {GetMessage(["2024"])}
          </p>)}
        </Col>
      </Row>
      <Row style={{marginBottom: "2rem"}}>
        <Col md="3">
        案内方法（下請）
        </Col>      
        <Col md="8">
          <InputRadio
            name='NOTIFICATION__want_guide_type_subcontract'
            disabled={this.subconSendSettingDisabled("dist","subcon")}
            disabled_options={this.sendSettingDisabledOptions("subcon")}
            options={
              [
                {
                    default : this.state.notification.values.want_guide_type_subcontract,
                    label : "両方",
                    value : 0,
                },
                {
                  label : "Eメール案内希望",
                  value : 1
                },
                {
                  label : "FAX案内希望",
                  value : 2,
                },
              ]
            }
            validateCallback={this.validateSendContact} 
            validateType='regist'
            rootData={this.state.notification}
            />          
        </Col>
      </Row>
    </>);
  }}

export class DialogInvoiceRequest extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '強制請求依頼をします。よろしいですか？',
      estimate: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      this.setState({
        estimate:this.props.data
      })
    }
  }

  handleClickPositive() {
    const {
      invoice_ulid,
      invoice_update_timestamp
    } = this.state.estimate.values;

    const updateParams = {
      invoice_ulid : invoice_ulid,
      updatetimestamp : invoice_update_timestamp,
    }
    Request.post(`/api/invoice/status`, { checked_data : [updateParams], invoice_process_status : 1}, 
      (res)=>{
        this.props.refreshCallback()
        this.toggleModal();
    })
    
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(<></>);
  }
}

export class DialogInvoiceLock extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      estimate: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      this.setState({
        title: `${this.props.data.values.invoice_lock_flag == 0 ? '請求ロックをします。' : '請求ロックを解除します。'}よろしいですか？`,
        estimate:this.props.data
      })
    }
  }
  
  handleClickPositive() {
    const {
      invoice_ulid,
      invoice_update_timestamp,
      invoice_process_status,
      invoice_lock_flag
    } = this.state.estimate.values;

    const updateParams = {
      invoice_ulid : invoice_ulid,
      updatetimestamp : invoice_update_timestamp,
      invoice_lock_flag : invoice_lock_flag == 0 ? 1 : 0
    }
    Request.post(`/api/invoice/status`, { checked_data : [updateParams], invoice_process_status }, 
      (res)=>{
        this.props.refreshCallback()
        this.toggleModal();
    })
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(<></>);
  }
}

export class DialogEstimateCancel extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      data: this.props.data
    });
    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      this.setState({
        title: `キャンセル申請します。よろしいですか？`,
        data:this.props.data
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    console.log("newData ", newData)
    this.setState({
      data:newData
    }, ()=>callback())
  }

  handleClickPositive() {
    const params = {
      ...this.state.data.values,
      estimate_cancel_status : 1
    }

    Request.put(`/api/quote/${this.state.data.values.ulid}`, params,
      (res)=>{
        this.props.refreshCallback()
        this.toggleModal();
    })
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(
    <>
      <InputText 
          multiline={true}
          labelOn={true}
          label='見積キャンセル申請理由'
          name='ESTIMATE__estimate_cancel_memo'
          copy="false"
          validateCallback={this.validateCallback} 
          rootData={this.state.data}
          validateType='regist'
        />
    </>);
  }
}

export class DialogInvoiceCustomer extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      data: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });

    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      const change_invoice_flag = this.props.data.values.change_invoice_flag
      const is_empty_change_invoice_name = 
      (this.props.data.values.change_invoice_name === null 
      || this.props.data.values.change_invoice_name === undefined
      || this.props.data.values.change_invoice_name === "") ? true : false;

      this.setState({
        title: `請求先を変更する場合は、以下を設定してください。`,
        data: {
          ...this.props.data,
          values : {
            ...this.props.data.values
          },
          errors:{ ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
          requiredData:{change_invoice_name : [GetMessage(2024)] },
        },
        inProcess : false
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    const change_invoice_flag = newData.values.change_invoice_flag
    const is_empty_change_invoice_name = 
      (newData.values.change_invoice_name === null 
      || newData.values.change_invoice_name === undefined
      || newData.values.change_invoice_name === "") ? true : false;
    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values: {
          ...newData.values,
          change_invoice_name : change_invoice_flag == 1 ? newData.values.change_invoice_name : null
        },
        errors:{ 
          ...(change_invoice_flag == 1 ? newData.errors : undefined),
          ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) 
        },
        requiredData : { ...(change_invoice_flag == 1 ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
      }
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    if(this.state.inProcess){
      return;
    }

    if (!this.validate()){
      return;
    }

    const {
      change_invoice_flag,
      change_invoice_name,
      update_timestamp,
      ulid
    } = this.state.data.values;

    const updateParams = {
      change_invoice_flag,
      change_invoice_name,
      update_timestamp
    }

    Request.put(`/api/quote/${ulid}`, updateParams, 
      (res)=>{
        this.setState({
          inProcess : true
        })
        this.props.refreshCallback()
        this.handleClickNegative();
    })
  }

  bodyContent(){
    const { change_invoice_flag } = this.state.data.values;
    return(
    <>
      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
          請求先情報
        </Col>
        <Col md="8">
        <InputRadio
          options={cst_invoice_change_flag}
          name='ESTIMATE__change_invoice_flag'
          validateCallback={this.validateCallback} 
          validateType='regist'
          rootData={this.state.data}
        />
      </Col>
      </Row>
      
      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
          請求先名
        </Col>
        <Col md="8">
          <InputText 
            name='ESTIMATE__change_invoice_name'
            validateCallback={this.validateCallback} 
            validateType='regist'
            rootData={this.state.data}
            disabled={change_invoice_flag == 0}
          />
        </Col>
      </Row>
    </>);
  }
}

export default List;
